import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zEntityAvailableState = z.object({
  stateId: zUid,
  workflowName: z.string(),
});
export type ZEntityAvailableState = z.infer<typeof zEntityAvailableState>;
